import generateBasicEntityActions from './generateBasicEntityActions';

const partnerEnterpriseActions = generateBasicEntityActions('partnerEnterprises', 'partnerEnterprise');

export default partnerEnterpriseActions;
